module.exports = __webpack_public_path__ + "img/sjkcsj.b520fd90.png";